import pdfMake from 'pdfmake/build/pdfmake'
import 'pdfmake/build/vfs_fonts'
import { Prescription } from '../../../types'
import { format, parseISO } from 'date-fns'
import { store } from '../../../app/store'
import { get, isArray } from 'lodash'

const str = (value: string | null | undefined) => value ?? ''

const openEOP = (docDefinition: any) => {
  pdfMake.createPdf(docDefinition).open()
}

export const printEvidenceOfPrescription = (prescriptions: Prescription | Prescription[]) => {
  const {
    clinic: {
      currentClinic: {
        name: practiceName,
        address_1,
        address_2,
        phone_number,
        state,
        suburb,
        postcode,
      } = {},
    },
  } = store.getState()

  const toBePrintedPrescriptions = isArray(prescriptions) ? prescriptions : [prescriptions]

  const pages = toBePrintedPrescriptions.map((prescription, index) => {
    const {
      scid,
      prescribedItems: [
        { displayName, tradeName, numberOfRepeatsAuthorised, quantity, patientInstructions },
      ],
      createdDate,
      issueSnapshot: {
        patient: { givenNames: patientGivenNames, familyName: patientFamilyName },
        prescriber: {
          givenNames: prescriberGivenNames,
          familyName: prescriberFamilyName,
          otherPhoneNumber,
          title: prescriberTitle,
        },
        location: prescriptionLocation,
      },
    } = prescription

    const usePrescriptionLocation = !!prescriptionLocation?.address1

    const prescriptionLocationDisplaySource = usePrescriptionLocation ? prescriptionLocation : {}
    const clinicDisplaySource = {
      name: practiceName,
      address1: address_1,
      address2: address_2,
      suburb,
      state,
      postcode: postcode,
      phoneNumber: phone_number,
    }
    const displaySource = usePrescriptionLocation
      ? prescriptionLocationDisplaySource
      : clinicDisplaySource
    const practiceNameDisplay = str(get(displaySource, 'name'))
    const address1Display = str(get(displaySource, 'address1'))
    const address2Display = str(get(displaySource, 'address2'))
    const suburbDisplay = str(get(displaySource, 'suburb'))
    const stateDisplay = str(get(displaySource, 'state'))
    const postcodeDisplay = str(get(displaySource, 'postcode'))
    const phoneDisplay = str(get(displaySource, 'phoneNumber'))

    const prescribedDate = parseISO(createdDate.toString())

    const page = [
      {
        columnGap: 16,
        columns: [
          {
            width: 450,
            fontSize: 14,
            stack: [
              {
                text: [
                  'Summary of electronic prescription for ',
                  { text: `${patientGivenNames} ${patientFamilyName}`, bold: true },
                ],
                fontSize: 16,
              },
              '\n',
              {
                text: displayName || tradeName,
                fontSize: 14,
                bold: true,
              },
              '\n',
              {
                table: {
                  widths: [300, '*'],
                  body: [
                    [{ text: 'Details', colSpan: 2 }, {}],
                    [{ text: 'Prescribed Date' }, { text: format(prescribedDate, 'dd/MM/yyyy') }],
                    [{ text: 'Repeats Authorised' }, { text: numberOfRepeatsAuthorised }],
                    [{ text: 'Quantity' }, { text: quantity }],
                    [{ text: 'Instructions' }, { text: patientInstructions }],
                  ],
                },
              },
              '\n',
              {
                text: 'This is an electronic prescription token only. The legal prescription must be downloaded for dispensing.',
                fontSize: 10,
              },
              '\n',
              {
                text: [
                  { text: 'Privacy Notice: ', bold: true },
                  'The privacy and security of your personal information is important to us, and is protected by law. We need to collect this information so we can process and manage your applications and payments, and provide services to you. We only share your information with other parties where you have agreed, or where the law allows or requires it. For more information, go to servicesaustralia.gov.au/privacy',
                ],
                fontSize: 10,
              },
            ],
          },
          {
            width: '*',
            fontSize: 14,
            alignment: 'right',
            stack: [
              { text: `${prescriberTitle} ${prescriberGivenNames} ${prescriberFamilyName}` },
              { text: practiceNameDisplay },
              { text: address1Display },
              { text: address2Display },
              { text: `${suburbDisplay} ${stateDisplay} ${postcodeDisplay}` },
              { text: `Phone: ${phoneDisplay}` },
              { text: `Other Phone: ${otherPhoneNumber ?? ''}` },
              '\n',
              { qr: scid, version: 2 },
              '\n',
              { text: scid, fontSize: 11 },
            ],
          },
        ],
      },
      '\n\n\n',
      {
        text: 'NOT TO BE SIGNED',
        alignment: 'center',
        fontSize: 56,
        color: 'grey',
      } as any,
    ]

    if (index < toBePrintedPrescriptions.length - 1) {
      page.push({
        text: '',
        pageBreak: 'after',
      })
    }

    return page
  })

  const dd = {
    defaultStyle: {
      fontSize: 9,
    },
    pageSize: 'A4',
    pageOrientation: 'landscape',
    pageMargins: [95, 95],
    content: pages,
  }
  openEOP(dd)
}
